var map = {
	"./ARCity.png": 6469,
	"./DataPioneers.png": 3054,
	"./DataStream.png": 6113,
	"./DigitalTwin.png": 8122,
	"./NOE-Map.png": 1018,
	"./Narrativ.png": 4935,
	"./PublicPrivacy.png": 5493
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2649;